import { APP_ROUTES } from '@/routes';
import { useAuthStore } from '@/modules/auth/stores/useAuthStore';
import { useRouter } from 'next/navigation';
import { useCart } from '@/modules/cart';

const useNavbar = () => {
	const { status } = useAuthStore();
	const { cartItems } = useCart();
	const router = useRouter();
	const handleGoToLogin = () => router.push(APP_ROUTES.AUTH.LOGIN);
	const handleGoToAccount = () => router.push(APP_ROUTES.ACCOUNT.PROFILE);
	const handleGoToCart = () => router.push(APP_ROUTES.PAYMENT.CART);
	const isAuth = status === 'authenticated';

	return {
		isAuth,
		handleGoToLogin,
		handleGoToAccount,
		handleGoToCart,
		cartItems,
	};
};

export default useNavbar;